import cn from 'classnames';

interface IProps {
  selected: boolean;
  onSelect: () => void;
}

const CardToCardPayment = ({selected, onSelect}: IProps) => {
  return (
    <div
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={e => e.key === 'Enter' && onSelect()}
      className={cn(
        'p-4 text-sm rounded-xl cursor-pointer transition',
        'bg-white shadow-sm border',
        selected
          ? 'border-farm-shop-500 ring-2 ring-farm-shop-500'
          : 'border-gray-50',
      )}
    >
      <div className="flex items-center gap-2">
        <input
          type="radio"
          checked={selected}
          readOnly
          className="scale-125 accent-farm-shop-500"
        />
        <span className="mr-3 font-medium text-zinc-900">
          پرداخت کارت به کارت / شماره شبا
        </span>
      </div>

      <div className="mt-1 mr-[34px] text-zinc-500">
        پرداخت بصورت کارت به کارت یا با استفاده از شماره شبا و ارسال فیش واریز
      </div>
    </div>
  );
};

export default CardToCardPayment;
